import { render, staticRenderFns } from "./Teacherauthority.vue?vue&type=template&id=6fb06631&scoped=true&"
import script from "./Teacherauthority.vue?vue&type=script&lang=js&"
export * from "./Teacherauthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb06631",
  null
  
)

export default component.exports